import styled from 'styled-components';

const UnstyledFieldset = styled.fieldset`
  display: contents;
`;

export default UnstyledFieldset;
